import { CenterMedianZone as CenterMedianZonePolygon } from '@domains/median-zones';
import { MapContext } from '@react-google-maps/api';
import { useContext } from 'react';

export const CenterMedianZone = () => {
  const mapRef = useContext(MapContext);
  return <CenterMedianZonePolygon mapRef={mapRef} />;
};
